import { Box, Card, Typography } from '@mui/material';

type FormFieldsetProps = {
  legend: string;
  hasError?: boolean;
  fullHeight?: boolean;
  children: JSX.Element;
  childrenTop?: boolean;
  noPadding?: boolean;
  displayInline?: boolean;
};

export const FormFieldset = (props: FormFieldsetProps) => {
  const { legend, hasError = false, fullHeight = false, children, childrenTop = false, noPadding = false, displayInline = false } = props;
  return (
    <Card
      variant='outlined'
      sx={{
        display: displayInline ? 'inline-block' : 'block',
        p: noPadding ? 0 : 0.5,
        m: 0,
        position: 'relative',
        overflow: 'visible',
        borderColor: (thm) => (hasError ? `${thm.palette.error.main} !important` : thm.palette.divider),
      }}
      component='fieldset'
    >
      <Typography
        component='legend'
        variant='caption'
        sx={{
          position: 'absolute',
          left: 5,
          top: -4,
          ml: 0.5,
          px: '5px',
          zIndex: 500,
          backgroundColor: '#fff',
          color: (thm) => (hasError ? thm.palette.error.light : 'rgba(0,0,0,0.6)'),
          lineHeight: 0.5,
        }}
      >
        {legend}
      </Typography>
      <Box
        sx={{
          ...(fullHeight && { height: '100%', display: 'flex', justifyContent: 'center', alignItems: childrenTop ? 'flex-start' : 'center' }),
        }}
      >
        {children}
      </Box>
    </Card>
  );
};
